import React from 'react';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import styled from 'styled-components';
import useReduxSelector from 'utils/useReduxSelector';

const LogoImage = styled.img`
  height: 32px;
  width: auto;
  max-width: 200px;

  @media (max-width: 768px) {
    height: 28px;
    width: auto;
    max-width: 160px;
  }
`;

export const OrgLogoImage = (): React.ReactElement | null => {
  const organizationLogo = useReduxSelector(loggedInUserSelectors.currentOrganization)?.logo;

  if (!organizationLogo) {
    return null;
  }

  const logoUrl = `/download?bucket=org-logos&key=${organizationLogo}&toCache=1`;

  return <LogoImage src={logoUrl} alt="Organization logo" />;
};

export default OrgLogoImage;
